export class RedirectComponent {
  redirectTo: string;

  constructor(props: any) {
    this.redirectTo = props.redirectTo;
  }
}

export default RedirectComponent;
